(function ($) {
  var halo = {
    initBrandsSlider: function () {
      var brandsSlider = $("[data-brands-slider]");

      brandsSlider.each(function () {
        var self = $(this);

        if (self.not(".slick-initialized")) {
          self.slick({
            slidesToShow: 5,
            slidesToScroll: 3,
            get dots() {
                return (this.dots = false);
            },
            infinite: false,
            speed: 800,
            get nextArrow() {
                return (this.nextArrow =
                  '<button type="button" class="slick-next" aria-label="Next"><i class="fa fa-angle-right"></i></button>');
            },
            get prevArrow() {
                return (this.prevArrow =
                  '<button type="button" class="slick-prev" aria-label="Prev"><i class="fa fa-angle-left"></i></button>');
            },
            responsive: [
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 5,
                  slidesToScroll: 5,
                  arrows: false,
                  get arrows() {
                      return (this.arrows = true);
                  },
                },
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  get arrows() {
                      return (this.arrows = true);
                  },
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  get arrows() {
                      return (this.arrows = true);
                  },
                },
              },
              {
                breakpoint: 480,
                settings: {
                  get slidesToShow() {
                      return (this.slidesToShow = 1);
                  },
                  get slidesToScroll() {
                      return (this.slidesToScroll = 1);
                  },
                  get arrows() {
                      return (this.arrows = true);
                  },
                },
              },
            ],
          });
        }
      });
    },
  };
  halo.initBrandsSlider();
})(jQuery);
